// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Location Selection',
  country: 'Country',
  searchCountry: 'Search country...',
  state: 'State / Province',
  found: 'found',
  selectState: 'Select State / Province',
  selectedLocation: 'Selected Location'
};
